import { render, staticRenderFns } from "./ServiceMetrics.vue?vue&type=template&id=a8c076c6&"
import script from "./ServiceMetrics.vue?vue&type=script&lang=js&"
export * from "./ServiceMetrics.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMetrics.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports